<template>
<div>
  
<div class="form-group">
<div  class="input-group">
   
        <div class="input-group">
        <div class="input-group-prepend"> 
          <div style="backgroundColor:navy;color:white;width:150px" class="input-group-text text-wrap"><strong>IDENTIFICAZIONE COUPON</strong></div>  
          <span class="input-group-text"> €</span>              
        </div>
       
        <input @input="submit()" v-focus type="number" :style="{fontSize: '30px'}" class="form-control" placeholder="Inserire il codice a barre COUPON" v-model = "barcode">                
       
        <button  @click="$emit('close',couponArray)" class="btn btn-warning"
           ><strong>CHIUDI</strong>          
        </button>
      
        </div>      
        

</div>
</div>        

    <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
    <span :style="{color:'blue',fontSize:'24px'}" class="text-center mt-2 mb-2"><strong> € {{ fmt1(total) }}</strong></span>      
    <table class="table table-sm mt-3 mb-3">
            <tr v-for="(item, index) in couponArray">
            <td>
              {{ index + 1 }}
            </td>
            <td>
              {{ item.barcode }}
            </td>
            <td class="text-right">
              <strong> {{ fmt1(item.total)}}</strong>
            </td>
            <td>
              <button class="btn btn-secondary btn-sm"  title="rimuovi coupon" v-on:click=" removeCoupon(index)">X</button>   
            </td>
            </tr>
    </table>  

</div>

</template>
<script>
import api                         from '@/api'
import { mapGetters }              from 'vuex';
import fmt                         from '@/components/mixins/fmt.js'
import alertBox                    from '@/components/common/AlertBox.vue'
export default {
  mixins :[fmt],
  components: {alertBox},
  data() {
    return {

      couponArray : [],
      barcode     : '',
      total       : 0,
      msg          : {
        title      : '',
        body       : '',
        type       : 0
      },
           
      
    };
  },
  directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()}
       
      }
    },
  computed: {
    ...mapGetters(['company','storeId']) 
  },
  mounted: function() {
      
  },
  created: function() {
     
  },
  methods: 
  {
    
    removeCoupon(index)
    {
      this.total -= this.couponArray[index].total
      this.couponArray.splice(index, 1) 
        
    },
    setTotal(item)    
    {   
        let check = 0
        this.couponArray.forEach(coupon =>{

            if(coupon.barcode == item.barcode)
            {
                check ++
            }
        })
        
        if(check)
        {
            return
        }
        
        this.total += item.total
        this.couponArray.push({'barcode' : item.barcode,'total':item.total,'couponId':item.couponId})
        
        //console.log(item)
    },
async submit()
{
  if(this.barcode.length != 13)
  {
    return
  }
  console.log(this.barcode)
  this.msg.title = ''
  const sp    = {'sp'       : 'spCouponIdentification'}
  const data  = {'barcode'  : this.barcode,
    'companyId'           : this.company.Id
    }  
  const json  = Object.assign(data, sp)

  this.spinner = true
  await api.post(json).then(res => {
          
          this.barcode = ''  
          if(res.status==200)
            {
              
              let coupon = res.data.recordsets[0][0]
              if(coupon)
              {  
                if(coupon.active == 0)
                {
                    
                    this.msg.title = 'ATTENZIONE '
                    this.msg.body  = 'COUPON NON ATTIVO.'
                    this.msg.type  = 1    
                }
                else
                {   
                    this.setTotal(coupon)
                     
                    //this.$emit('update',coupon)
                    
                }
              }
              else
              {
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'COUPON NON TROVATO'
                this.msg.type  = 1
              }


            }
           else if(res.status==500)
           {
               
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                
                 
            } 
          

          }).catch(err => {
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });


},

}

}
</script>
<style scoped>

</style>